module.exports = __webpack_public_path__ + "img/support.190e6298.svg";